import { Field } from "src/shared/contexts/HackerContext/types";
import {
  isEmail,
  isLatinOnly,
  isPhoneNumber,
  isValidDiscordTag,
  isValidSocialMediaURL,
} from "src/shared/utils/validation";

export const LATIN_ONLY_MESSAGE =
  "Due to technical limitations, we only support latin characters";

export const NETWORKING_TEXT_FIELDS = [
  Field.NETWORKING_PHONE,
  Field.NETWORKING_EMAIL,
  Field.LINKEDIN,
  Field.INSTAGRAM,
  Field.TWITTER,
  Field.DISCORD_TAG,
];

export const isValidBadgeSocialURL = (value: string, platform: string) =>
  isValidSocialMediaURL(value, platform) ||
  (platform === "x" && isValidSocialMediaURL(value, "twitter"));

export const ACCEPTED_FIELDS = [
  Field.NETWORKING_PHONE,
  Field.NETWORKING_EMAIL,
  Field.LINKEDIN,
  Field.INSTAGRAM,
  Field.TWITTER,
  Field.DISCORD_TAG,
  Field.BADGE_RSVP_STAGE,
  Field.TRAVEL_RSVP_STAGE,
  Field.PERSONAL_RSVP_STAGE,
];

export const validateSocials = (responsesState: any) => {
  const socialMediaFields = [
    { field: Field.LINKEDIN, platform: "linkedin" },
    { field: Field.INSTAGRAM, platform: "instagram" },
    { field: Field.TWITTER, platform: "x" },
  ];

  const hasErrors = socialMediaFields.some(({ field, platform }) => {
    const value = responsesState[field];
    return value && !isValidBadgeSocialURL(value, platform);
  });

  const discordValue = responsesState[Field.DISCORD_TAG];
  const hasDiscordError = discordValue && !isValidDiscordTag(discordValue);

  const phoneValue = responsesState[Field.NETWORKING_PHONE];
  const hasPhoneError = phoneValue && !isPhoneNumber(phoneValue);

  const emailValue = responsesState[Field.NETWORKING_EMAIL];
  const hasEmailError = emailValue && !isEmail(emailValue);

  return !hasErrors && !hasDiscordError && !hasPhoneError && !hasEmailError;
};

export const validateLatinOnly = (responsesState: any) =>
  NETWORKING_TEXT_FIELDS.every((field) => isLatinOnly(responsesState[field]));
